import { render, staticRenderFns } from "./QuoteBlock.vue?vue&type=template&id=4bb0f6d8&scoped=true&"
import script from "./QuoteBlock.vue?vue&type=script&lang=js&"
export * from "./QuoteBlock.vue?vue&type=script&lang=js&"
import style0 from "./QuoteBlock.vue?vue&type=style&index=0&id=4bb0f6d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb0f6d8",
  null
  
)

export default component.exports